import { SectionProps } from './ts'

function Section({ logo, text, title, image }: SectionProps) {
  return (
    <div className="flex flex-col items-center justify-between space-x-0 justify-items-center 2lg:odd:flex-row-reverse 2lg:even:flex-row lg:px-16 gap-[100px]">
      <div className="align-middle lg:w-2/4">
        <div className="flex mb-2 align-middle">
          {logo ? (
            <div className="w-16 mr-1 xl:w-28 lg:w-20 3xs:w-16 3xs:mr-2 2xs:w-16 2xs:m4-2 xs:w-16 sm:w-16 md:w-16 2lg:w-16">
              {logo}
            </div>
          ) : null}
          <h3 className="text-2xl font-medium sm:text-2xl lg:text-4xl xl:text-5xl">
            {title}
          </h3>
        </div>
        <p className="text-gray-100 sm:text-l lg:text-xl xl:text-2xl">{text}</p>
      </div>
      <div className="mb-16 xl:w-1/3 lg:w-1/3 xs:w-3/4 sm:w-1/2 md:w-1/2 2lg:w-4/5">
        {image}
      </div>
    </div>
  )
}

export default Section
